import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { ModalResultType } from '@models';
import { MailService } from '@services';
import UiValidators, { UI_EMAIL_MAX_LENGTH } from '@validators';

import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
    templateUrl: './mail.modal.html',
    providers: [FormBuilder, MailService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MailModalComponent
    extends UiModalComponent<any>
    implements OnInit {

    public form!: FormGroup;
    public loading$ = new BehaviorSubject(false);

    private _appState = this._injector.get<AppStateFacade>(AppStateFacade);
    private _mailService = this._injector.get<MailService>(MailService);
    private _sendTo = this._appState.user.value!.emailAddress;

    ngOnInit() {
        this.form = this._injector.get<FormBuilder>(FormBuilder).group({
            'sendTo': [
                this._sendTo,
                Validators.compose([
                    UiValidators.required(),
                    Validators.email,
                    Validators.maxLength(UI_EMAIL_MAX_LENGTH),
                ])],
        });
    }

    public onSubmit() {
        if (!this.form.valid || this.loading$.value) {
            return;
        }

        this.loading$.next(true);
        this._sendTo = this.form.value.sendTo;

        this._mailService.send(this._sendTo, this.context.data)
            .pipe(
                finalize(
                    () => this.loading$.next(false),
                ),
            )
            .subscribe({
                error: () =>
                    this._dialogRef.close({
                        type: ModalResultType.Failed,
                    }),
                complete: () =>
                    this._dialogRef.close({
                        type: ModalResultType.Succeeded,
                        additionalData: this._sendTo,
                    }),
            });
    }
}
